"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BASE_CLASS_NAME = "mdc-list";
//# sourceMappingURL=constants.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@react-mdc/list/lib/constants.js
// module id = ./node_modules/@react-mdc/list/lib/constants.js
// module chunks = 1